import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import HistoryIcon from "@mui/icons-material/Menu";
import Close from "@mui/icons-material/Close";
// Limitless imports
import { ClientContext } from "@limitless/common/utils";
import { useWebSockets } from "@limitless/common/hooks/web-sockets/WebSocketsContext";
import { getWebSocketStatusColor } from "@limitless/common/hooks/web-sockets/WebSocketsHelper";
import { useTranslation } from "@limitless/common/hooks";
const useStyles = makeStyles(theme => {
  var _theme$typography$hea, _theme$typography, _theme$typography$hea2;
  const headerStyles = {
    "@media screen and (min-width: 450px)": {
      root: {
        borderTopLeftRadius: "12px",
        borderTopRightRadius: "12px",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)",
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main
      }
    },
    toolbarGutters: {
      flex: 1,
      justifyContent: "space-between",
      backgroundColor: getWebSocketStatusColor
    },
    menuIconHide: {
      width: "48px"
    },
    titleText: {
      fontWeight: (_theme$typography$hea = (_theme$typography = theme.typography) === null || _theme$typography === void 0 ? void 0 : (_theme$typography$hea2 = _theme$typography.headerText) === null || _theme$typography$hea2 === void 0 ? void 0 : _theme$typography$hea2.fontWeight) !== null && _theme$typography$hea !== void 0 ? _theme$typography$hea : theme.typography.fontWeightRegular
    }
  };
  if (!ClientContext._headerButtonHoverEnabled) {
    headerStyles.iconButton = {
      "&:hover": {
        backgroundColor: "transparent"
      }
    };
  }
  return headerStyles;
});
const Header = ({
  title,
  onCloseHandle,
  fullScreen,
  onLeftIconClickHandle,
  leftIcon
}) => {
  const [showStatus, setShowStatus] = React.useState(false);
  const {
    wsStatus
  } = useWebSockets();
  const classes = useStyles({
    showStatus,
    wsStatus
  });
  const {
    t
  } = useTranslation();
  React.useEffect(() => {
    if (window.LLM) {
      window.LLM.showWebSocketStatus = val => {
        if (typeof val === "boolean") {
          setShowStatus(val);
        }
      };
    }
  }, []);
  const renderLeftIcon = () => {
    let style;
    if (!onLeftIconClickHandle) {
      style = {
        visibility: "hidden"
      };
    }
    return /*#__PURE__*/React.createElement(IconButton, {
      color: "inherit",
      onClick: onLeftIconClickHandle,
      style: style,
      component: "div",
      "aria-label": leftIcon ? t("Messenger Help") : t("Conversation History"),
      classes: {
        root: classes.iconButton
      },
      size: "large"
    }, leftIcon ? leftIcon : /*#__PURE__*/React.createElement(HistoryIcon, null));
  };
  return /*#__PURE__*/React.createElement("div", {
    position: "relative",
    className: fullScreen ? "" : `${classes.root}`
  }, /*#__PURE__*/React.createElement(Toolbar, {
    classes: {
      root: classes.toolbarGutters
    },
    disableGutters: true
  }, renderLeftIcon(), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    id: "conversationHistory",
    color: "inherit",
    className: classes.titleText
  }, t(title)), /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": t("Close Messenger"),
    onClick: onCloseHandle,
    classes: {
      root: classes.iconButton
    },
    component: "div",
    id: "closeMessenger",
    size: "large"
  }, /*#__PURE__*/React.createElement(Close, null))));
};
export default Header;
Header.propTypes = {
  title: PropTypes.string.isRequired,
  onCloseHandle: PropTypes.func,
  onLeftIconClickHandle: PropTypes.func,
  leftIcon: PropTypes.node,
  fullScreen: PropTypes.bool
};